import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  DatePicker,
  Form,
  Input,
  Progress,
  Select,
  Space,
  Switch,
  TimePicker,
  Upload,
  message,
} from 'antd';
import moment from 'moment';
import Cookies from 'js-cookie';
import axios from '../../backendService';
import axiosUpload from '../../backendServiceForUpload';
import { FaVideo, FaImage } from 'react-icons/fa6';
import ScheduleLectureForm from './Schedule-leacture-form';
import AWS from 'aws-sdk';

// S3 Configuration
const S3_BUCKET = 'hls-streaming-classroom';
const REGION = 'ap-south-1';
const ACCESS_KEY = 'AKIA4T4OCFU2JPJX5VW5';
const SECRET_ACCESS_KEY = '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';

// Define separate folders for different content types
const IMAGE_FOLDER = 'thumbnails';

const s3 = new AWS.S3({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
  region: REGION,
  endpoint: 'https://hls-streaming-classroom.s3.ap-south-1.amazonaws.com',
  s3ForcePathStyle: true,
  signatureVersion: 'v4',
  s3BucketEndpoint: true,
});

const ScheduleLiveLectureForm = ({ courseData = [], batchData = [], courseLoading = true }) => {
  const [form] = Form.useForm();

  const [formdata, setFormdata] = useState({
    selectedCourse: '',
    selectedSubject: '',
    selectedChapter: '',
    selectedbatch: [],
    selectedTopics: '',
  });

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imageFileName, setImageFileName] = useState('');
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showUploadBar, setShowUploadBar] = useState(true);
  const [imageUploadPercentage, setImageUploadPercentage] = useState(0);
  const [showImageUploadBar, setShowImageUploadBar] = useState(true);
  const [formSubmitPercentage, setFormSubmitPercentage] = useState(0);
  const [showFormSubmitBar, setShowFormSubmitBar] = useState(true);
  const [currentUploadTask, setCurrentUploadTask] = useState(null);
  const [currentImageUploadTask, setCurrentImageUploadTask] = useState(null);
  const [videoURL, setVideoURL] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [updatedImageURL, setUpdatedImageURL] = useState(null);
  const [imageReady, setImageReady] = useState(null);
  const [imageUploadStatus, setImageUploadStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [topicList, setTopicList] = useState([]);
  const [courseId, setCourseId] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [chapterId, setChapterId] = useState('');
  const [topicId, setTopicId] = useState('');
  const [toPublish, setToPublish] = useState(true);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [formKey, setFormKey] = useState(0);

  const clearUploadedFile = () => {
    setUploadPercentage(0);
    setVideoURL(null);
    form.setFieldValue('newVideoFile', null);
    form.setFieldValue('videoURL', null);
    if (currentUploadTask) {
      currentUploadTask.cancel();
    }
    setFileName('');
    setFile(null);
  };

  const clearUploadedImageFile = async () => {
    await deleteUploadedImage(uploadedImageName);
    setImageUploadStatus('');
    setImageUploadPercentage(0);
    setImageURL(null);
    form.setFieldValue('videoThumbnail', null);
    form.setFieldValue('imageURL', null);
    setImageFileName('');
    setImageFile(null);
  };

  const clearUploadedImageFileAfterSubmission = async () => {
    setImageUploadStatus('');
    setImageUploadPercentage(0);
    setImageURL(null);
    form.setFieldValue('videoThumbnail', null);
    form.setFieldValue('imageURL', null);
    setImageFileName('');
    setImageFile(null);
  };

  const userId = Cookies.get('userId');

  // Generate session ID each time on page refresh
  const [sessionId, setSessionId] = useState('');

  function generateRandomLetters(length) {
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const generateSessionID = () => {
    const randomString = [
      generateRandomLetters(3),
      generateRandomLetters(3),
      generateRandomLetters(3),
      generateRandomLetters(3),
    ].join('-');
    return randomString;
  };

  useEffect(() => {
    const generatedSessionId = generateSessionID();
    setSessionId(generateSessionID);
  }, []);

  useEffect(() => {
    setSubjectList([]);
    setChapterList([]);
    setTopicList([]);
    form ? form.setFieldValue('batches', []) : null;
    form ? form.setFieldValue('subjectName', null) : null;
    form ? form.setFieldValue('chapterName', null) : null;
    form ? form.setFieldValue('topicName', null) : null;

    const filteredCourseData = courseData.filter((course) => {
      return course._id === courseId;
    });

    filteredCourseData.map((course) => {
      let subjectObjects = [];
      course.subjects.map((subject) => {
        subjectObjects.push(subject);
      });
      setSubjectList(subjectObjects);
    });

    setFilteredBatches(batchData.filter((batch) => batch.course._id === courseId));
  }, [courseId]);

  useEffect(() => {
    setChapterList([]);
    setTopicList([]);
    form ? form.setFieldValue('chapterName', null) : null;
    form ? form.setFieldValue('topicName', null) : null;

    const filteredSubjectData = subjectList.filter((subject) => {
      return subject._id === subjectId;
    });

    let chapterObjects = [];
    if (filteredSubjectData.length) {
      filteredSubjectData[0].chapters.map((chapter) => {
        chapterObjects.push(chapter);
      });
      setChapterList(chapterObjects);
    }
  }, [subjectId]);

  useEffect(() => {
    setTopicList([]);
    form ? form.setFieldValue('topicName', null) : null;

    const filteredchapterData = chapterList.filter((chapter) => {
      return chapter._id === chapterId;
    });

    let topicObjects = [];
    if (filteredchapterData.length) {
      filteredchapterData[0].topics.map((topic) => {
        topicObjects.push(topic);
      });
      setTopicList(topicObjects);
    }
  }, [chapterId]);

  useEffect(() => {
    if (imageURL) {
      let finalImageURL = imageURL;

      // If imageURL doesn't contain the full endpoint, construct it
      if (!imageURL.includes('https://')) {
        finalImageURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${IMAGE_FOLDER}/${imageURL}`;
      } else if (imageURL.includes('amazonaws.com')) {
        finalImageURL = imageURL;
      } else {
        const urlParts = imageURL.split('/');
        const fileName = urlParts[urlParts.length - 1];
        finalImageURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${IMAGE_FOLDER}/${fileName}`;
      }

      setUpdatedImageURL(finalImageURL);
      console.log('Final Image URL:', finalImageURL);
    }
  }, [imageURL]);

  const handleNewVideoFormSubmit = async (values) => {
    setLoading(true);

    if (formdata.selectedbatch.length === 0) {
      return message.error('Please Select one batch');
    } else if (!formdata.selectedSubject) {
      return message.error('Please Select Subject');
    } else if (!formdata.selectedChapter) {
      return message.error('Please Select Chapter');
    } else if (!formdata.selectedTopics) {
      return message.error('Please Select Topics');
    }

    const params = new URLSearchParams();

    params.append('roomKey', sessionId);
    params.append('thumbnailURL', updatedImageURL);
    params.append('title', values.title);
    params.append('description', values.description);
    params.append('course', courseId);
    params.append('subject', subjectId);
    params.append('chapter', chapterId);
    params.append('topic', topicId);
    params.append('teacher', userId);

    let data = {
      roomKey: sessionId,
      thumbnailURL: updatedImageURL,
      title: values.title,
      description: values.description,
      course: formdata.selectedCourse,
      subject: formdata.selectedSubject,
      chapter: formdata.selectedChapter,
      topic: formdata.selectedTopics,
      teacher: userId,
      batches: formdata.selectedbatch,
    };

    if (values.publishDate && values.startTime && values.endTime) {
      const date = form.getFieldValue('publishDate').format('YYYY-MM-DD');
      const formattedStartTime = form.getFieldValue('startTime').format('HH:mm');
      const formattedEndTime = form.getFieldValue('endTime').format('HH:mm');
      data = { ...data, publishDate: date, startTime: formattedStartTime, endTime: formattedEndTime };
      params.append('publishDate', date);
      params.append('startTime', formattedStartTime);
      params.append('endTime', formattedEndTime);
    }

    try {
      const res = await axios.post('/videos/createSessionWithThumbnailUrls', data, {
        headers: {
          'Content-Type': 'application/json',
        },
        onUploadProgress: (p) => {
          const percentageCompleted = Math.round((p.loaded * 100) / p.total);
          setFormSubmitPercentage(percentageCompleted);
          setShowFormSubmitBar(true);
        },
      });

      setFormKey(prevKey => prevKey + 1);
      setLoading(false);
      setShowFormSubmitBar(false);
      clearUploadedFile();
      clearUploadedImageFileAfterSubmission();
      setToPublish(false);
      setSessionId(generateSessionID);
      form.resetFields();
      if (values.publishDate && values.startTime && values.endTime) {
        message.success('Lecture uploaded and scheduled for streaming');
      } else {
        message.success('Lecture uploaded successfully you may reschedule it as needed.');
      }
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
      setLoading(false);
      setFormSubmitPercentage(0);
      message.error('Something went wrong, check if all fields are correct');
    }
  };

  // Updated image file upload with S3 direct upload and folder structure
  const handleImageFileUpload = async (file) => {
    setImageReady(false);
    setShowImageUploadBar(true);
    setImageUploadPercentage(0);

    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
    const updatedFileName = file.name.replace(/\s/g, '') + '_' + uniqueSuffix;

    // Store images in a separate 'thumbnails' folder
    const s3Key = `${IMAGE_FOLDER}/${updatedFileName}`;

    setUploadedImageName(updatedFileName);

    const params = {
      Bucket: S3_BUCKET,
      Key: s3Key,
      Body: file,
      ContentType: file.type,
    };

    try {
      setImageUploadStatus('Uploading in progress...');

      s3.upload(params, (err, data) => {
        if (err) {
          console.error('S3 Upload Image Error:', err);
          message.error('Image upload failed');
          setImageReady(false);
          setShowImageUploadBar(false);
          return;
        }

        if (data && data.Location) {
          setImageURL(data.Location);
          setImageUploadStatus('Image uploaded successfully.');
          setImageReady(true);
          message.success('Image uploaded successfully');
        } else {
          const constructedURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${s3Key}`;
          setImageURL(constructedURL);
          setImageUploadStatus('Image uploaded successfully.');
          setImageReady(true);
          message.success('Image uploaded successfully');
        }

        setShowImageUploadBar(false);
      }).on('httpUploadProgress', (progressData) => {
        const calculatedProgress = Math.round((progressData.loaded / progressData.total) * 100);
        setImageUploadPercentage(calculatedProgress);
      });
    } catch (error) {
      console.error('Error uploading image:', error);
      message.error('Failed to upload image');
      setImageReady(false);
      setShowImageUploadBar(false);
    }
  };

  const deleteUploadedImage = async (fileName) => {
    try {
      await axios.delete(`/videos/gets3objects/delete-from-s3/${IMAGE_FOLDER}/${fileName}`);
      message.success(`Thumbnail deleted successfully, upload a new thumbnail`);
    } catch (error) {
      console.error('Error deleting thumbnail:', error);
      message.error('Failed to delete thumbnail');
    }
  };

  const handleBatchSelect = (selectedId) => {
    form.setFieldValue({ batches: selectedId });
  };

  return (
    <>
      <Form layout={'vertical'} form={form} onFinish={handleNewVideoFormSubmit}>
        <Form.Item name="roomKey">
          <Space size={'large'} style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'end' }}>
            <p className="mb-0">Generated Room Key :</p>
            <Input value={sessionId} disabled />
          </Space>
        </Form.Item>

        <Space size={'large'} style={{ display: 'flex', justifyContent: 'start' }} wrap>
          <Form.Item
            size="large"
            name="videoThumbnail"
            rules={[{ required: true, message: 'Please upload a video thumbnail' }]}
          >
            <Upload
              style={{ width: '100%' }}
              maxCount={1}
              beforeUpload={(file) => {
                const isAllowedType = ['image/jpg', 'image/jpeg', 'image/png'].includes(file.type);
                const isWithinSizeLimit = file.size <= 400 * 1024;
                if (!isAllowedType) {
                  message.error('Only jpg, jpeg, png files are allowed');
                  return Upload.LIST_IGNORE;
                }
                if (!isWithinSizeLimit) {
                  message.error('Image size must be within 400 KB');
                  return Upload.LIST_IGNORE;
                }
                return true;
              }}
              customRequest={(info) => {
                handleImageFileUpload(info.file);
                setImageFile(info.file);
                setImageFileName(info.file.name);
              }}
              showUploadList={false}
            >
              <Button
                style={{ width: '100%' }}
                size="large"
                type="primary"
                icon={<FaImage />}
                className="text-sm text-blue-700 gap-2 flex items-center justify-start"
              >
                Upload a thumbnail
              </Button>
            </Upload>
          </Form.Item>
          {imageFileName !== '' && imageUploadStatus == 'Image uploaded successfully.' && (
            <Form.Item size={'large'}>
              <Space wrap>
                {imageFileName ? imageFileName : ''}
                {imageFileName !== '' && (
                  <Button
                    onClick={clearUploadedImageFile}
                    type="default"
                    size="small"
                    className="bg-red-500 text-white"
                  >
                    Delete
                  </Button>
                )}
              </Space>
            </Form.Item>
          )}
          {imageUploadStatus !== '' && (
            <div className="text-xs text-green-500" style={{ color: 'green' }}>
              {imageUploadStatus}
            </div>
          )}
        </Space>

        {/* Image upload bar */}
        <div className="mb-5">{showImageUploadBar && <Progress percent={imageUploadPercentage} />}</div>

        <Form.Item name="title" rules={[{ required: true, message: 'Please enter video title!' }]}>
          <Input placeholder="Enter video title" />
        </Form.Item>
        <Form.Item
          name="description"
          placeholder="Enter video description"
          rules={[{ required: true, message: 'Please enter video description!' }]}
        >
          <Input.TextArea placeholder="Enter video description" />
        </Form.Item>
        
        <ScheduleLectureForm key={formKey} setFormdata={setFormdata} />
        
        <Space style={{ display: 'flex', justifyContent: 'start' }} size={'large'} wrap>
          <Form.Item
            size={'large'}
            name="publishDate"
            label="Lecture schedule date"
            rules={[{ required: true, message: 'Please select a date!' }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Select schedule date"
              disabledDate={(current) => {
                return current && current < moment().startOf('day');
              }}
            />
          </Form.Item>
          <Form.Item
            size={'large'}
            name="startTime"
            label="Lecture start time"
            rules={[{ required: true, message: 'Please select a start time!' }]}
          >
            <TimePicker placeholder="Lecture start time" format={'HH:mm'} />
          </Form.Item>
          <Form.Item
            size={'large'}
            name="endTime"
            label="Lecture end time"
            rules={[{ required: true, message: 'Please select a end time!' }]}
          >
            <TimePicker placeholder="Lecture end time" format={'HH:mm'} />
          </Form.Item>
        </Space>
        <Form.Item>
          <Button disabled={imageReady === false} size="large" type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
      {showFormSubmitBar && <Progress percent={formSubmitPercentage} className=" z-99998" />}
    </>
  );
};

export default ScheduleLiveLectureForm;